import React, { useState } from "react";
import { api, euro, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { HandCoins } from "lucide-react";

const eur = (n) => euro(n);

export const AgentPayoutRequest = ({ data, onDone }) => {
  const [busy, setBusy] = useState(false);
  const min = data.payout_min ?? 100;
  const ask = async () => {
    setBusy(true);
    try { const { data: d } = await api.post("/agent/payout-request"); toast.success(`Richiesta di liquidazione di ${eur(d.amount)} inviata`); onDone(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Richiesta non riuscita"); }
    finally { setBusy(false); }
  };
  const msg = data.payout_request ? `Richiesta inviata: ${eur(data.payout_request.amount)} in attesa di pagamento.`
    : data.requested_this_month ? "Hai già fatto la richiesta di questo mese: potrai farne un'altra il mese prossimo."
    : data.outstanding >= min ? `Hai ${eur(data.outstanding)} da liquidare: puoi chiederne il pagamento.`
    : `Puoi chiedere la liquidazione una volta al mese, da ${eur(min)} maturati (ora ${eur(data.outstanding)}).`;
  const can = !data.payout_request && !data.requested_this_month && data.outstanding >= min;
  return <Card className="p-4 flex flex-wrap items-center justify-between gap-3" data-testid="agent-payout-request">
    <p className="flex items-center gap-2 text-sm"><HandCoins className="w-5 h-5 text-primary" /><span data-testid="agent-payout-request-msg">{msg}</span></p>
    <Button size="sm" disabled={!can || busy} onClick={ask} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="agent-payout-request-submit">{busy ? "Invio…" : "Richiedi liquidazione"}</Button>
  </Card>;
};
